import React from 'react';

const LoveLetter: React.FC = () => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        fontFamily: 'Georgia, serif'
      }}
    >
      <div 
        className="max-w-2xl w-full bg-white rounded-lg shadow-2xl p-8 md:p-12"
        style={{
          background: 'linear-gradient(to bottom, #fffef7 0%, #fff9e6 100%)',
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          border: '1px solid rgba(220, 200, 180, 0.3)'
        }}
      >
        {/* Decorative header */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-2">💌</div>
          <div 
            className="text-sm uppercase tracking-widest mb-4"
            style={{ color: '#8b6f47', letterSpacing: '0.2em' }}
          >
            For my princess
          </div>
        </div>

        {/* Date */}
        <div 
          className="text-right mb-6 text-sm italic"
          style={{ color: '#8b6f47' }}
        >
          December 4, 2025
        </div>

        {/* Letter content */}
        <div 
          className="space-y-6 leading-relaxed"
          style={{ 
            color: '#3d3d3d',
            fontSize: '18px',
            lineHeight: '1.8'
          }}
        >
          <p className="indent-8">
            Safa,
          </p>

          <p className="indent-8">
          My first ever letter I wrote was when you were my gf and my second ever letter is to you as my fiance 😁. I know you think it’s corny when I say I love you even more than I did yesterday, but I’m never lying. Everyday I grow a little closer to you and youre a core part of my life and who I am now. Even though I see you everyday, it’s still never enough for me lol. I can’t wait till the day we’re married and get to spend all our hours together
          </p>

          <p className="indent-8">
          I’m so grateful everything with our parents and us getting lowkey engaged worked out so amazingly. It still feels like a dream that this is all happening and we’re actually getting married inshallah. When we used to talk about our future and marriage before meeting our parents, it all felt so far away, but now it’s so real Alhamdullilah. I’m excited about all the memories we will make next year and the rest of our lives
          </p>

          <p className="indent-8">
          I’ve told you how all my life I’ve gotten very used to being by myself and alone and I was pretty fine with that, in fact it’s what I preferred. I love my parents and I love my friends, but I always felt most at peace when I was alone. Now I feel that same peace when I’m with you
          </p>

          <p className="indent-8">
          I know 24 days is quite a long time and tbh it didn’t really hit me how long it was until I started writing this letter, but I will love you no matter how far I am in distance or time. I’m always a call away no matter what
          </p>

          <p className="indent-8">
          I will see you soon 🫶🏾
          </p>
        </div>

        {/* Signature */}
        <div className="mt-12 text-right">
          <div 
            style={{ 
              color: '#3d3d3d'
            }}
          >
            Tahmid
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoveLetter;

